<template>
  <l-layout :layout="['xs12']">
    <v-form ref="parkForm">
      <v-card class="pa-3">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="园区名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag">
              </v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="园区等级" prepend-icon="$vuetify.icons.level" v-model="form.level" :disabled="disabledFlag">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-select label="所属机构" prepend-icon="$vuetify.icons.group" :items="form.orgSelect" v-model="form.org"
                        :disabled="disabledFlag"
              item-text="name" item-value="id"></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <l-autocomplete
                :get-data="getParksByName"
                item-text="name"
                label="父园区选择"
                multiple
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.parentParksId"
                :disabled="disabledFlag"
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="园区描述" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow v-model="form.description" :disabled="disabledFlag">
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout justify-center>
          <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="addPark">提交</v-btn>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
export default {
  name: 'newPark',
  data () {
    return {
      form: {
        org: '',
        name: '',
        level: '',
        description: '',
        parentParksId: [],
        orgSelect: [],
        parentParkSelect: []
      },
      loading: false,
      disabledFlag: false,
    }
  },
  computed: {
  },
  created () {
    this.getOrgSelect()
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getOrgSelect () {
      try {
        let items = await this.$store.dispatch('login/getAvailableIns')
        this.form.orgSelect = items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    async getParksByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getParkList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    checkForm () {
      return true
    },
    async addPark () {
      if (this.checkForm()) {
        let ids = []
        for (let i = 0; i < this.form.parentParksId.length; i++) {
          ids.push(this.form.parentParksId[i].id)
        }
        let params = {
          'name': this.form.name,
          'description': this.form.description,
          'parkLevel': this.form.level,
          'institutionId': this.form.org,
          'latitude': '',
          'longitude': '',
          'parentParksId': ids,
          'extend':null
        }
        this.loading = true
        let res = await this.$store.dispatch('park/addPark', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '添加成功'})
          this.disabledFlag = true
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
